module.exports = __webpack_public_path__ + "static/media/(DH)_MG_5995_-_Pro-Natura_-_Moda_Feminina_-_Moda_Bebe.dde1d3ba.jpg";